import React from "react";
import { Stack } from "@mui/material";
import { observer } from "mobx-react";
import { SurveyControlPreferencesSettings } from "../SurveyControlPreferencesSettings";
import { useSurveyStore } from "../../../../store/Hooks";
import { useTranslation } from "react-i18next";
import {
  useFoundationColorTokens,
  useSpacing,
  useTypography,
} from "@surya-digital/leo-reactjs-material-ui";
import { useRouteNavigator } from "../../../../../routes/RoutesHelper";
import { CloseReopenSurveySection } from "../CloseReopenSurveySection";
import { SurveySettingsTabContentHeader } from "../SurveySettingsTabContentHeader";
import { SurveySettingsTab } from "../SurveySettingsPaneTab";

export const SurveySettingsSurveyControlTab: React.FC = observer(() => {
  const { t } = useTranslation();
  const spacing = useSpacing();
  const typography = useTypography();
  const tokens = useFoundationColorTokens();
  const navigateTo = useRouteNavigator();
  const surveyStore = useSurveyStore();

  const updatedBackOfficeSurveySettings =
    surveyStore.backOfficeSurveySettingsStore.updatedBackOfficeSurveySettings;

  if (!updatedBackOfficeSurveySettings) return;

  const surveySettings = updatedBackOfficeSurveySettings.surveySettings;

  return (
    <Stack id={SurveySettingsTab.SurveyControl}>
      <SurveySettingsTabContentHeader
        title={t(
          "surveys.settings.surveyControlSectionLabel",
          "Survey Control",
        )}
      />
      <SurveyControlPreferencesSettings
        isAutoProgressEnabled={surveySettings.isAutoProgressEnabled}
        setIsAutoProgressEnabled={
          updatedBackOfficeSurveySettings.setIsAutoProgressEnabled
        }
        isProgressPercentageShown={surveySettings.isProgressPercentageShown}
        setIsProgressPercentageShown={
          updatedBackOfficeSurveySettings.setIsProgressPercentageShown
        }
        isIpTracked={surveySettings.isIpTracked}
        setIsIpTracked={updatedBackOfficeSurveySettings.setIsIpTracked}
        isResponseResetAllowed={surveySettings.isResponseResetAllowed}
        setIsResponseResetAllowed={surveySettings.setIsResponseResetAllowed}
        isRespondentConsentRequired={surveySettings.isRespondentConsentRequired}
        setIsRespondentConsentRequired={
          updatedBackOfficeSurveySettings.setIsRespondentConsentRequired
        }
        isRatingScaleOptionVisible={surveySettings.isRatingScaleOptionVisible}
        setIsRatingScaleOptionVisible={
          updatedBackOfficeSurveySettings.setIsRatingScaleOptionVisible
        }
        t={t}
        spacing={spacing}
        typography={typography}
        tokens={tokens}
      />
      <CloseReopenSurveySection
        navigateTo={navigateTo}
        surveyStore={surveyStore}
        t={t}
        spacing={spacing}
        typography={typography}
        tokens={tokens}
        backOfficeSurveySettingsStore={
          surveyStore.backOfficeSurveySettingsStore
        }
      />
    </Stack>
  );
});
